export const CART_MUTATION_KEY = ['cart-mutation'];
export const cartKeys = {
   cart: ['shopify-cart'],
};
